import { useState, useEffect } from "react";
import slide1 from 'assets/img/slide1.jpg';
import slide2 from 'assets/img/slide2.jpg';
import slide3 from 'assets/img/slide3.jpg';
import logo from 'assets/img/szeuslogo.png';

const bgImages = [slide1, slide2, slide3];

const SigninLayout = ({ children }) => {
  const [currentImage, setCurrentImage] = useState(0);

  useEffect(() => {
    const timer = setTimeout(() => {
      setCurrentImage((prev) => (prev === 2 ? 0 : prev + 1));
    }, 5000);
    return () => clearTimeout(timer);
  }, [currentImage]);

  return (
    <div className="signin img-slideshow">
      {bgImages.map((src, i) => (
        <div
          key={src}
          className="signin-bg-slide"
          style={{ backgroundImage: `url('${src}')`, opacity: i === currentImage ? 1 : 0 }}
        />
      ))}
      <div className="App main-content">
        <div className="header py-7 py-lg-7 pt-lg-6">
          <div className="container">
            <div className="header-body text-center mb-5">
              <div className="row justify-content-center">
                <div className="col-xl-5 col-lg-6 col-md-8 px-5">
                  <img src={logo} className="navbar-brand-img" alt="ZEUS" />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="container-login container-fluid mt--8 pb-5">
          {children}
        </div>
        <div className="sign-in-footer">
          <div className="row" style={{ color: '#fff' }}>Version: 1.0</div>
          <div className="row" style={{ color: '#fff' }}>© Zuragon, all rights reserved</div>
        </div>
      </div>
    </div>
  );
};

export default SigninLayout;
